import React from "react";
import LegalPage from "./LegalPage";

export default function Shipping() {
  return <LegalPage pageKey="shipping" testId="shipping-page" />;
}
